import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import {clientAppUserChangePassword } from "../../../store/actions/User";

import Loading from "../../Loading/Loading";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css'
import {  Link  } from "react-router-dom";
const AddNewPassWordT1 = ()=>{
 
    const data = useSelector((state)=>state?.user?.user);

 const dispatch = useDispatch();
 const handleMouseEnter = () =>dispatch({
  type: "CURSOR",
  
  payload:true
});
const handleMouseLeave = () => dispatch({
  type: "CURSOR",
  
  payload:false
});


    const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  


  const history = useHistory();
 
 const [loader , setLoader] =useState({status:false});
 const [AddNewPassword, setAddNewPassword] = useState({newPassword:'',userEmail:data?.userData?.userEmail,clientCurrentToken:data?.currentToken
 
});

useEffect(() => {
      })


/* Handle Signup Function */
const handleAddNewPassword=(e)=>{
  e.preventDefault();
console.log(AddNewPassword)

setLoader({status:true});
  const user = dispatch(clientAppUserChangePassword(AddNewPassword));
  /* get response as Promise   */
  user.then(response => {
  
    if(response){
      
    console.log(response)
      dispatch({
        type: "LoginSignUpPopUp",
        
        payload:""
      })
    }else{


    }
    ;
   

/* resetting Login input Fields */

setAddNewPassword({newPassword:'',userEmail:'',clientCurrentToken:''

})

setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
    
/* resetting Login input Fields */
setAddNewPassword({newPassword:'',userEmail:'',clientCurrentToken:''

})
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleAddNewPassword} >
  {loginSignUpPopUp=="addNewPassword"?<div onClick={() => dispatch({
    type: "LoginSignUpPopUp",
    
    payload:""
  })}  className="cm_theme1_login-signup-backgropj"></div>:""} 
    
    <div  className="cm_theme1_login-signup-card"><div  className="blank"> </div>
  <div  className="cm_theme1_login-signup-card-outerj"><div  className="cm_theme1_login-signup-inner">
  <div  className="cm_theme1_blankRight ">
  <div  className="flex-space-between">  <div  style={{width:"240px",padding:"15px",borderRadius:"15px",marginTop:"10px"}}><img style={{width:"100%"}}
               alt="logo" src="https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"/> </div>
        
              </div>
              
        <h3  style={{textAlign:"center"}}>App Tag Line</h3>
    </div>  <div  className="cm_theme1_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Add New Password </h1>
      
 <div  className="cm_theme1_login-input-card">
 <input className="cm_theme1_input-textbox" required placeholder="New Password" type="text"
  name="newPassword" value={AddNewPassword.newPassword} 
  onChange={(e)=>setAddNewPassword({...AddNewPassword, newPassword : e.target.value})} />
   </div>
	  
   
   
    
   
     
   
	
	<div  className="cm_theme1_login-input-card">
   
  <button  className="cm_theme1_login-signup-button" type="submit" id="signupBtn">Update New Password</button>
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div>
   </form>
</>}
    </>

}
export default AddNewPassWordT1;